import { useCallback, useEffect, useRef, useState } from "react";
import { apiRequest } from "../../shared/api/client";
import type { Notify, NotificationRow } from "./admin-types";
import { useAdminRequestScope } from "./useAdminRequestScope";

export function useAdminNotificationsWorkspace({notify}: {notify: Notify}) {
  const scope = useAdminRequestScope(notify);
  const [rows, setRows] = useState<NotificationRow[]>([]);
  const [testSubmitting, setTestSubmitting] = useState(false);
  const pending = useRef(false);
  const load = useCallback(() => {
    if (!scope.isMounted()) return;
    const request = scope.beginRead();
    void apiRequest<NotificationRow[]>("/api/notifications").then(value => {
      if (scope.isCurrentRead(request)) setRows(value);
    }).catch((error: unknown) => {
      if (scope.isCurrentRead(request)) scope.notify(error instanceof Error ? error.message : "Bildirimler alınamadı.");
    });
  }, [scope]);
  useEffect(load, [load]);
  const sendTestEmail = async () => {
    if (!scope.isMounted() || pending.current) return;
    pending.current = true;
    setTestSubmitting(true);
    try {
      const row = await apiRequest<NotificationRow>("/api/notifications/test-delivery", {method: "POST"});
      if (!scope.isMounted()) return;
      scope.invalidateReads();
      setRows(current => [row, ...current.filter(item => item.id !== row.id)]);
      scope.notify(row.status === "SENT"
        ? "Test e-postası gönderildi. Gelen kutunuzu kontrol edin."
        : `Test e-postası gönderilemedi: ${row.last_error ?? "Gönderim sonucu alınamadı."}`);
    } catch (error) {
      scope.notify(error instanceof Error ? error.message : "Test e-postası gönderilemedi.");
    } finally {
      pending.current = false;
      if (scope.isMounted()) setTestSubmitting(false);
    }
  };
  return {rows, testSubmitting, sendTestEmail};
}
